import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineMinus,
  AiOutlinePlus
} from "react-icons/ai";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { DeliveryImageModal } from "../../../../../components/DeliveryImageModal";
import { Loading } from "../../../../../components/Loading";
import ProfileEnum from "../../../../../enums/ProfileEnum";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import { momentBDays } from "../../../../../utils/MomentBDay";
import { formatOwnCollectStartAndEnd } from "../../../../../utils/OwnCollectTime";
import styles from "./styles.module.scss";
import { RouteOwnCollectStatusEnum } from "../../../../../enums/RouteOwnCollectStatusEnum";
import { VscNote } from "react-icons/vsc";
import { FaRunning, FaTruckLoading } from "react-icons/fa";
import { TbBoxOff } from "react-icons/tb";
import { CardOwnCollectStage } from "../../../components/CardOwnCollectStage";
import { FiEdit3 } from "react-icons/fi";
import { isWithinLastThreeDays } from "../../Collect/ShippingDetail/components/EditPackageStatusModal/utils/verifyDate";
import { EditOwnCollectStatusModal } from "./components/EditOwnCollectStatusModal";
import { EditOwnCollectImageModal } from "./components/EditOwnCollectImageModal";

const timelineCollect = [
  {
    text: "Criada",
    icon: <VscNote />,
    value: "Coleta criada"
  },
  {
    text: "Em trânsito",
    icon: <FaTruckLoading />,
    value: "Motorista em rota para coleta"
  },
  {
    text: "Saiu para coleta",
    icon: <FaRunning />,
    value: "Motorista saiu para coleta"
  },
  {
    text: "Erro na coleta",
    icon: <AiOutlineCloseCircle />,
    value: "Coleta extraviada"
  },
  {
    text: "Coleta Realizada",
    icon: <AiOutlineCheckCircle />,
    value: "Coleta Realizada"
  },
  {
    text: "Não coletada",
    icon: <AiOutlineCloseCircle />,
    value: "Não foi possível realizar a coleta"
  },
  {
    text: "Cancelada",
    icon: <TbBoxOff />,
    value: "Coleta Cancelada"
  },
];


const OwnCollectDetail = () => {
  const params = useParams();
  const api = new BrComerceApiService();
  const { auth } = store.getState();
  const { user } = auth;

  const [loading, setLoading] = useState(false);

  const [ownCollect, setOwnCollect] = useState();

  const [timeline, setTimeline] = useState([]);
  const [trackings, setTrackings] = useState([]);
  const [lastTracking, setLastTracking] = useState({});

  const [cardsExpand, setCardsExpand] = useState([]);

  const [showEditStatusButton, setShowEditStatusButton] = useState(false);
  const [showEditStatusModal, setShowEditStatusModal] = useState(false);
  const [imageIndexToEdit, setImageIndexToEdit] = useState(undefined);

  const [showImageModal, setShowImageModal] = useState(false);
  const [dataImage, setDataImage] = useState({
    urlImage: "",
    text: ""
  });

  const deliveriesData = ownCollect?.deliveriesData?.length ? ownCollect?.deliveriesData : []
  const lastDelivery = deliveriesData.length ? deliveriesData[deliveriesData.length - 1] : undefined

  const userData = ownCollect?.user?.userData
  const userName = userData?.length ? userData[1]?.Value : ""

  const statusData = ownCollect?.routeData?.status ? Object.entries(RouteOwnCollectStatusEnum).find(
    st => st[1].id === ownCollect?.routeData?.status
  ) : RouteOwnCollectStatusEnum.PENDENTE
  const status = statusData?.length ? statusData[1].name : RouteOwnCollectStatusEnum.PENDENTE.name

  const handleMountTime = track => {
    const timeline = [];

    track.forEach(item => {
      timelineCollect.find(itemTimeline => {
        if (itemTimeline.text === item.status) timeline.push({ ...itemTimeline, statusId: item?.statusId });
      });
    });

    const uniqueArray = [timeline[0]];

    for (let i = 1; i < timeline.length; i++) {
      if (timeline[i] !== timeline[i - 1]) {
        uniqueArray.push(timeline[i]);
      }
    }

    setTimeline(uniqueArray);
  };

  const handleTrackingDescriptions = ownCollect => {
    const mappedTracking = [];

    if (ownCollect?.created_at) {
      const data = ownCollect?.created_at
      const statusTracking = "Criada"
      mappedTracking.push(
        {
          status: statusTracking,
          date: momentBDays(data).format("DD/MM/YYYY - HH:mm"),
          description: ownCollect?.collectAddress?.city || "",
          icon: timelineCollect.find(tc => tc.text === statusTracking)?.icon
        }
      )
    }

    if (ownCollect?.routeData?.route_own_collect_created) {
      const data = ownCollect?.routeData?.started_at
      const statusTracking = "Em trânsito"
      mappedTracking.push(
        {
          statusId: RouteOwnCollectStatusEnum.EM_ROTA_DE_COLETA.id,
          status: statusTracking,
          date: data ? momentBDays(data).format("DD/MM/YYYY - HH:mm") : undefined,
          description: ownCollect?.collectAddress?.city || "",
          icon: timelineCollect.find(tc => tc.text === statusTracking)?.icon,
          correiosDescription: timelineCollect.find(tc => tc.text === statusTracking)?.value,
        }
      )
    }

    const deliveriesData = ownCollect?.deliveriesData?.length ? ownCollect?.deliveriesData : []
    const lastDelivery = deliveriesData.length ? deliveriesData[deliveriesData.length - 1] : undefined
    const ownCollectRouteStatus = ownCollect?.routeData?.status

    if (ownCollectRouteStatus === RouteOwnCollectStatusEnum.COLETADO.id && !!lastDelivery?.delivery_date) {
      const data = lastDelivery?.delivery_date
      const statusTracking = "Coleta Realizada"
      mappedTracking.push(
        {
          statusId: ownCollect?.routeData?.status,
          status: statusTracking,
          date: momentBDays(data).format("DD/MM/YYYY - HH:mm"),
          description: ownCollect?.collectAddress?.city || "",
          icon: timelineCollect.find(tc => tc.text === statusTracking)?.icon,
          correiosDescription: timelineCollect.find(tc => tc.text === statusTracking)?.value,
        }
      )
    }

    if (!!ownCollectRouteStatus &&
      ownCollectRouteStatus !== RouteOwnCollectStatusEnum.COLETADO.id &&
      ownCollectRouteStatus !== RouteOwnCollectStatusEnum.EM_ROTA_DE_COLETA.id &&
      ownCollectRouteStatus !== RouteOwnCollectStatusEnum.PENDENTE.id) {

      const data = lastDelivery?.delivery_date
      const statusTracking = ownCollectRouteStatus === RouteOwnCollectStatusEnum.EXTRAVIADO.id ? "Erro na coleta" : "Não coletada"
      
      const failStatusData = Object.entries(RouteOwnCollectStatusEnum).find(st => st[1].id === ownCollectRouteStatus);
      const failReasonText = failStatusData ? failStatusData[1].name : timelineCollect.find(tc => tc.text === statusTracking)?.value;

      mappedTracking.push(
        {
          statusId: ownCollect?.routeData?.status,
          status: statusTracking,
          date: momentBDays(data).format("DD/MM/YYYY - HH:mm"),
          description: ownCollect?.collectAddress?.city || "",
          icon: timelineCollect.find(tc => tc.text === statusTracking)?.icon,
          correiosDescription: failReasonText,
        }
      )
    }

    const lastStatus = mappedTracking.slice(-1);
    setLastTracking(lastStatus[0]);

    handleMountTime(mappedTracking);
    setTrackings(mappedTracking);
  };

  const handleCEP = value => {
    return value.replace(/\D/g, "").replace(/^(\d{5})(\d{3})/, "$1-$2");
  };

  const handlePhone = value => {
    value = value.replace(/\D/g, "");
    if (value.length === 11) {
      value = value.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else if (value.length === 10) {
      value = value.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else if (value.length === 13) {
      value = value.replace(/^(\d{2})(\d{2})(\d{4})(\d{4})/, "+$1 ($2) $3-$4");
    }

    return value;
  };

  const handleCPFAndCnpj = value => {
    if (value.length <= 11) {
      return value
        .replace(/\D/g, "")
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
      return value
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  };

  const handleDataFormat = ownCollect => {
    if (!ownCollect) return;

    const OwnCollectFormatted = {
      ...ownCollect,
      collectAddress: {
        ...ownCollect?.collectAddress,
        zip: handleCEP(ownCollect?.collectAddress.zip),
        phone: handlePhone(ownCollect?.collectAddress.phone),
        document: handleCPFAndCnpj(ownCollect?.collectAddress?.document)
      },
      routeData: {
        ...ownCollect?.routeData,
        ...(ownCollect?.routeData?.started_at && { started_at: momentBDays(ownCollect?.routeData?.started_at).format("DD/MM/YYYY - HH:mm") }),
        ...(ownCollect?.routeData?.finalized_at && { finalized_at: momentBDays(ownCollect?.routeData?.finalized_at).format("DD/MM/YYYY - HH:mm") }),
      }
    };

    setOwnCollect(OwnCollectFormatted);
  };

  const handleObjectExpand = object => {
    const find = cardsExpand.find(obj => obj === object);
    if (find) {
      const newObject = cardsExpand.filter(obj => obj !== object);
      setCardsExpand([...newObject]);
    } else {
      cardsExpand.push(object);
      setCardsExpand([...cardsExpand]);
    }
  };

  const handleStatusColor = statusId => {
    if (!statusId) return ""

    const color = {
      [RouteOwnCollectStatusEnum.COLETADOR_NAO_ATENDIDO.id]:
        "#FF6B71",
      [RouteOwnCollectStatusEnum.COLETADOR_NAO_FINALIZOU_COLETA.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.AREA_DE_RISCO.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.CLIENTE_DESCONHECIDO.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.CLIENTE_MUDOU.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.CLIENTE_RECUSOU.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.CLIENTE_SEM_DOCUMENTO.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.EMPRESA_SEM_EXPEDIENTE.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.ENDERECO_COM_NUMERACAO_IRREGULAR.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.ENDERECO_INCORRETO.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.EXTRAVIADO.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.CONDICOES_CLIMATICAS_ADVERSAS.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.ERRO_NA_ROTEIRIZACAO.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.MUDANCA_DE_MODALIDADE.id]: "#FF6B71",
      [RouteOwnCollectStatusEnum.PENDENTE.id]: "#FFAF52",
    };

    return color[statusId] && lastTracking.statusId === statusId ? color[statusId] : "";
  };

  const handleCloseImageButton = () => {
    setDataImage({
      urlImage: "",
      text: ""
    });
    setShowImageModal(false);
  };

  const handleCloseEditImageButton = () => {
    setImageIndexToEdit(undefined);
  };

  const handleEditImage = (index) => {
    setImageIndexToEdit(index?.toString())
  }

  const handleEditStatus = () => {
    setShowEditStatusModal(true)
  }

  const handleFetchData = async () => {
    try {
      setLoading(true);
      const id = params.id;

      const relations = '["user", "collectAddress"]';
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `/own-collect/${id}/details`,
        params: {
          relations,
        }
      });

      handleDataFormat(response);
      handleTrackingDescriptions(response);

    } catch (e) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Rastreio",
        text: "Não encontramos informações sobre esse objeto!"
      });
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await handleFetchData();
    })();
  }, [params]);

  useEffect(() => {
    if (!!ownCollect) {
      const deliveryDate = ownCollect.deliveriesData?.length
        ? ownCollect.deliveriesData[0].delivery_date
        : undefined

      const show =
        user && user.profile === ProfileEnum.ADMIN.value &&
        ownCollect.routeData?.status === RouteOwnCollectStatusEnum.EM_ROTA_DE_COLETA.id || !!deliveryDate && isWithinLastThreeDays(deliveryDate)

      setShowEditStatusButton(show)
    }
  }, [ownCollect]);

  window.setPageTitle("Detalhes da Coleta");

  return (
    <>
      <Loading loading={loading} />
      {showImageModal && (
        <DeliveryImageModal
          urlImage={dataImage.urlImage}
          text={dataImage.text}
          handleCloseButton={handleCloseImageButton}
          isOpen={showImageModal}
        />
      )}

      {showEditStatusModal &&
        ownCollect &&
        (
          <EditOwnCollectStatusModal
            isOpen={showEditStatusModal}
            handleCloseModal={() => setShowEditStatusModal(false)}
            ownCollect={ownCollect}
            refetch={handleFetchData}
          />
        )}

      {!!imageIndexToEdit &&
        !Number.isNaN(imageIndexToEdit) &&
        ownCollect &&
        (
          <EditOwnCollectImageModal
            isOpen={!!imageIndexToEdit}
            handleCloseButton={handleCloseEditImageButton}
            ownCollect={ownCollect}
            imageIndex={Number(imageIndexToEdit)}
            refetch={handleFetchData}
          />
        )}

      <Container fluid className={styles.container}>
        <Row className={`h-100 justify-content-between`}>
          <Col className={`col ${styles.trackingContainer}`}>
            <div className={styles.header}>
              <div className={styles.title}>
                <h2>Detalhes da Coleta Própria</h2>
              </div>
            </div>

            <div className={styles.subheader}>
              <div className={styles.code}>
                <div>
                  <h3>Código de identificação: </h3>
                  <span>{ownCollect?.id}</span>
                </div>

                {ownCollect?.previewDate && (
                  <div>
                    <h3>Previsão de coleta: </h3>
                    <span>
                      {moment(ownCollect?.previewDate).format("DD/MM/YYYY")}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {window.screen.width > 769 ?
              <div className={styles.timelineContainer}>
                {timeline.map((item, index) => {
                  return (
                    <div className={styles.content} key={`${index}-timeline-item`}>
                      <div className={styles.statusContainer}>
                        <div
                          style={{
                            background: handleStatusColor(item?.statusId)
                          }}
                          className={styles.status}
                        >
                          {item?.icon}
                        </div>
                        <span
                          style={{
                            color: handleStatusColor(item?.statusId)
                          }}
                        >
                          {item?.text}
                        </span>
                      </div>
                      <div className={styles.dotContainer}>
                        {timeline?.length - 1 !== index && (
                          <>
                            {[...Array(3)].map((element, index) => (
                              <div key={`${index}-item`} className={styles.dot} />
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              : <></>}

            {!!ownCollect ? (
              <div className={styles.cardsList}>
                {trackings?.map((tracking, index) => {
                  return (
                    <CardOwnCollectStage
                      cardData={tracking}
                      key={`${index}-cardShipping`}
                      type={tracking.type}
                      last={trackings?.length - 1 === index}
                    />
                  );
                })}
                {showEditStatusButton && <div className={styles.editStatusButton}>
                  <span onClick={handleEditStatus}> <FiEdit3 /> {ownCollect?.routeData?.status === RouteOwnCollectStatusEnum.EM_ROTA_DE_COLETA.id ? "Adicionar" : "Alterar"} coleta</span>
                </div>}
              </div>
            ) : (
              <div
                className={`d-flex justify-content-center align-items-center ${styles.trackingNotFound}`}
              >
                <h2>Ainda não temos informações de rastreio.</h2>
              </div>
            )}

            {ownCollect?.deliveriesData && (
              <div className={styles.deliveryInformation}>
                <div className={styles.header}>
                  <div className={styles.title}>
                    <h2>Evidência da coleta</h2>
                  </div>
                </div>
                {ownCollect?.deliveriesData[0]?.urlImage ? (
                  <div className={styles.containerImages}>
                    {ownCollect?.deliveriesData?.map((data, index) => {
                      return (
                        <div key={`${index}-tentativas`}>
                          <span>
                            <strong>{"Coleta realizada com sucesso: "}</strong>
                            {data.success ? "Sim" : "Não"}
                          </span>
                          <span>
                            <strong>{"Data: "}</strong>
                            {moment(data.delivery_date).format(
                              "DD/MM/YYYY - HH:mm"
                            )}
                          </span>
                          <span>
                            <strong>{"Assinado por: "}</strong>
                            {data.success ? data.signed_by : "--"}
                          </span>
                          <span>
                            <strong>{"Documento: "}</strong>
                            {data.success ? data.document : "--"}
                          </span>
                          <img
                            src={data.urlImage}
                            alt={`Coleta ${index}`}
                            onClick={() => {
                              setDataImage({
                                urlImage: data.urlImage,
                                text: `${index + 1}ª Tentativa de coleta`
                              });
                              setShowImageModal(true);
                            }}
                          />

                          {showEditStatusButton && <button className={styles.editImageButton} onClick={() => handleEditImage(index)}> <FiEdit3 /> Editar foto</button>}

                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    className={`d-flex justify-content-center align-items-center ${styles.trackingNotFound}`}
                  >
                    <h2>Ainda não temos informações de coleta</h2>
                  </div>
                )}
              </div>
            )}
          </Col>
          <Col xs={12} xl={5} className={`${styles.packageInfoContainer}`}>
            <div className={styles.packageTitle}>
              <h3>Informações da coleta</h3>
            </div>
            <Row className={`${styles.packageInfo} m-0`}>
              <Col xs={12} className={`${styles.contentWrapper} p-0`}>
                <div className={styles.packageHeader} onClick={() => handleObjectExpand("Endereço")}>
                  <h3>DADOS DO ENDEREÇO</h3>
                  {cardsExpand.includes("Endereço") ? (
                    <AiOutlineMinus
                      color="#409E6A"
                      size={22}
                    />
                  ) : (
                    <AiOutlinePlus
                      color="#409E6A"
                      size={22}
                    />
                  )}
                </div>
                <div
                  className={
                    cardsExpand.includes("Endereço")
                      ? styles.packageBody
                      : styles.packageBodyHidden
                  }
                >
                  <Row>
                    <Col xs={12} md={6}>
                      <strong>Nome:</strong>
                      <p>{ownCollect?.collectAddress?.name}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Endereço:</strong>
                      <p>{ownCollect?.collectAddress?.street}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>CPF/CNPJ:</strong>
                      <p>{ownCollect?.collectAddress?.document}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Número:</strong>
                      <p>{ownCollect?.collectAddress?.number}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Complemento:</strong>
                      <p>{ownCollect?.collectAddress?.complement || "-"}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Telefone:</strong>
                      <p>{ownCollect?.collectAddress?.phone || "-"}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Bairro:</strong>
                      <p>{ownCollect?.collectAddress?.district}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>CEP:</strong>
                      <p>{ownCollect?.collectAddress?.zip}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Cidade:</strong>
                      <p>{ownCollect?.collectAddress?.city}</p>
                      <strong>Estado:</strong>
                      <p>{ownCollect?.collectAddress?.state}</p>
                    </Col>
                    <Col xs={12}>
                      <strong>Observações:</strong>
                      <p>{ownCollect?.collectAddress?.observation || "-"}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xs={12} className={`${styles.contentWrapper} p-0`}>
                <div className={styles.packageHeader} onClick={() => handleObjectExpand("Coleta")}>
                  <h3>DADOS DA COLETA</h3>

                  {cardsExpand.includes("Coleta") ? (
                    <AiOutlineMinus
                      color="#409E6A"
                      size={22}
                    />
                  ) : (
                    <AiOutlinePlus
                      color="#409E6A"
                      size={22}
                    />
                  )}
                </div>
                <div
                  className={
                    cardsExpand.includes("Coleta")
                      ? styles.packageBody
                      : styles.packageBodyHidden
                  }
                >
                  <Row>
                    <Col xs={12} md={6}>
                      <strong>Modalidade:</strong>
                      <p>
                        Coleta Própria
                      </p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Janela da coleta:</strong>
                      <p>
                        {formatOwnCollectStartAndEnd(ownCollect?.collectTimeStart, ownCollect?.collectTimeEnd)}
                      </p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Usuário:</strong>
                      <p>{userName}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Status:</strong>
                      <p>{status}</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <strong>Realizada em:</strong>
                      <p>{lastDelivery?.delivery_date ? moment(lastDelivery?.delivery_date).format(
                        "DD/MM/YYYY - HH:mm"
                      ) : "--"}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
              {user?.profile === ProfileEnum.ADMIN.value && (
                <Col xs={12} className={`${styles.contentWrapper} p-0`}>
                  <div className={styles.packageHeader}>
                    <h3>Informações para o Administrador</h3>
                  </div>
                  <div className={styles.packageBody}>
                    <Row>
                      <Col xs={12} md={6}>
                        <strong>Rota:</strong>
                        <p>{ownCollect?.routeData?.id ?? "--"}</p>
                      </Col>
                      <Col xs={12} md={6}>
                        <strong>Motorista:</strong>
                        <p>{ownCollect?.routeData?.driver?.name ?? "--"}</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { OwnCollectDetail };

